/**
 * External links used throughout the dashboard.
 */

// @TODO Replace with the real external ticket-creation URL once it is finalized.
export const REPORT_ISSUE_URL = 'https://roareducation.zendesk.com/hc/en-us/requests/new';
